export default __webpack_public_path__ + "static/media/h5-section1-bg6.5fb193a9.png";